(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-links"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initManualCollections() {

    const sections = document.querySelectorAll(
      '.manual-collection-section'
    );

    sections.forEach(section => {

      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      const preview = section.querySelector(
        '.manual-collection-preview'
      );

      const slides = Array.from(
        section.querySelectorAll('.image-slider .slide')
      );

      const links = Array.from(
        section.querySelectorAll('.collection-link-item')
      );

      if (!preview || !slides.length || !links.length) return;

      let currentIndex = 0;

      function activateSlide(index) {

        if (index < 0 || index >= slides.length) return;

        slides.forEach(slide => {
          slide.classList.remove('active');
        });

        links.forEach(link => {
          link.classList.remove('active');
        });

        slides[index].classList.add('active');
        links[index].classList.add('active');

        currentIndex = index;

      }

      // Desktop hover
      links.forEach((link, index) => {

        link.addEventListener('mouseenter', () => {
          activateSlide(index);
        });

        link.addEventListener('focus', () => {
          activateSlide(index);
        });

      });

      // Mobile swipe
      let startX = null;

      preview.addEventListener('touchstart', e => {

        startX = e.touches[0].clientX;

      }, { passive: true });

      preview.addEventListener('touchend', e => {

        if (startX === null) return;

        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {

          let nextIndex;

          if (diff > 0) {

            nextIndex = (currentIndex + 1) % slides.length;

          } else {

            nextIndex = (
              currentIndex - 1 + slides.length
            ) % slides.length;

          }

          activateSlide(nextIndex);

        }

        startX = null;

      }, { passive: true });

    });

  }

  document.addEventListener(
    'DOMContentLoaded',
    initManualCollections
  );

  document.addEventListener(
    'shopify:section:load',
    initManualCollections
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullwidth-banner-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("bannerTrack");
  let slides = Array.from(track.children);
  const prev = document.getElementById("prevSlide");
  const next = document.getElementById("nextSlide");

  let currentIndex = 0;
  let slideWidth;
  let autoInterval;
  let isTransitioning = false;

  // Clone first and last slides for seamless loop
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);
  track.appendChild(firstClone);
  track.insertBefore(lastClone, slides[0]);
  slides = Array.from(track.children);

  const setSlideWidth = () => {
    slideWidth = slides[0].offsetWidth;
    track.style.transform = `translateX(-${slideWidth * (currentIndex + 1)}px)`;
  };

  const moveToSlide = (index) => {
    if (isTransitioning) return;
    isTransitioning = true;
    track.style.transition = "transform 0.8s ease";
    track.style.transform = `translateX(-${slideWidth * (index + 1)}px)`;
    currentIndex = index;
  };

  const handleTransitionEnd = () => {
    isTransitioning = false;
    if (currentIndex >= slides.length - 2) {
      track.style.transition = "none";
      currentIndex = 0;
      track.style.transform = `translateX(-${slideWidth}px)`;
    }
    if (currentIndex < 0) {
      track.style.transition = "none";
      currentIndex = slides.length - 3;
      track.style.transform = `translateX(-${slideWidth * (currentIndex + 1)}px)`;
    }
  };

  const nextSlide = () => moveToSlide(currentIndex + 1);
  const prevSlide = () => moveToSlide(currentIndex - 1);

  // Auto slide
  const startAuto = () => (autoInterval = setInterval(nextSlide, 4000));
  const stopAuto = () => clearInterval(autoInterval);

  // Swipe
  let startX = 0;
  track.addEventListener("touchstart", e => (startX = e.touches[0].clientX));
  track.addEventListener("touchmove", e => {
    const diff = e.touches[0].clientX - startX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? prevSlide() : nextSlide();
      startX = 0;
    }
  });

  // Hover pause
  track.addEventListener("mouseenter", stopAuto);
  track.addEventListener("mouseleave", startAuto);

  // Events
  next.addEventListener("click", nextSlide);
  prev.addEventListener("click", prevSlide);
  track.addEventListener("transitionend", handleTransitionEnd);
  window.addEventListener("resize", setSlideWidth);

  // Init
  setSlideWidth();
  startAuto();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {

  /* IMAGE SLIDER FADE */
  const slides = document.querySelectorAll("#fpws-slider-{{ section.id }} .fpws-slide");
  let index = 0;

  if (slides.length > 1) {
    setInterval(() => {
      slides[index].classList.remove("active");
      index = (index + 1) % slides.length;
      slides[index].classList.add("active");
    }, 3500);
  }

  /* VARIANT SELECTOR */
  const priceBox = document.getElementById("price-{{ section.id }}");
  const qtyInput = document.getElementById("qty-{{ section.id }}");
  const variantButtons = document.querySelectorAll("#variant-buttons-{{ section.id }} .fpws-variant-btn");

  let activeVariant = null;

  function setVariant(button) {
    activeVariant = {
      id: button.dataset.id,
      price: parseFloat(button.dataset.price)
    };

    const qty = parseInt(qtyInput.value);
    priceBox.innerHTML = Shopify.formatMoney(activeVariant.price * qty, "{{ shop.money_format }}");

    variantButtons.forEach(b => b.classList.remove("active"));
    button.classList.add("active");
  }

  variantButtons.forEach(btn => {
    btn.addEventListener("click", () => setVariant(btn));
  });

  if (variantButtons.length > 0) setVariant(variantButtons[0]);

  qtyInput.addEventListener("input", () => {
    if (activeVariant)
      priceBox.innerHTML = Shopify.formatMoney(activeVariant.price * qtyInput.value, "{{ shop.money_format }}");
  });

  /* AJAX ADD TO CART */
  document.getElementById("add-to-cart-{{ section.id }}").addEventListener("click", () => {

    if (!activeVariant) return alert("Please select a variant");

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: activeVariant.id,
        quantity: qtyInput.value
      })
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = "/cart"; // redirect to cart
    })
    .catch(err => alert("Error adding to cart"));
  });

});

  } catch(e) { console.error(e); }
})();
})();
